<template>
    <website-page centered>
        <b-card class="rounded" style="width: 350px; max-width: 100%;">
            <i class="fas fa-lock fa-2x text-primary"/>
            <h4 class="mt-3" v-tr>Password Required|Mot de passe requis</h4>
            <b-input-group size="lg">
                <b-input-group-text><i class="fas fa-key"/></b-input-group-text>
                <e-input type="password" v-model="password"/>
            </b-input-group>
            <b-btn class="mt-3" variant="primary" @click="submit" v-tr>Submit|Enregistrer</b-btn>
        </b-card>
    </website-page>
</template>

<script>
import EInput from "@vue-components/components/e-input.vue";

export default {
    name: `password-required`,
    components: {EInput},
    data() {
        return {
            password: ``
        }
    },
    methods: {
        submit() {
            localStorage.setItem(`password`, this.password);
            this.$store.state.applicationReady = false;
            window.history.back();
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
